import React, { useContext, useState } from "react";
import ReactMarkdown from "react-markdown";
import remarkGfm from "remark-gfm";
import Button from "../../components/Button/Button";
import Input, { TextArea } from "../../components/Input/Input";
import GlobalContext from "../../context/GlobalContext";
import events from "../../utils/events";
import "./write.scss";

const Write = () => {
	const [newBlog, setNewBlog] = useState({
		title: "",
		image: "",
		about: "",
		event: "",
		content: "",
	});
	const { breakpoint } = useContext(GlobalContext);
	const handleChange = (e) => {
		const { name, value } = e.target;
		setNewBlog((p) => ({
			...p,
			[name]: value,
		}));
	};
	const handleReset = (e) => {
		e?.preventDefault();
		setNewBlog({
			title: "",
			image: "",
			about: "",
			event: "",
			content: "",
		});
	};
	const handleSubmit = (e) => {
		e?.preventDefault();
	};
	return (
		<main className="write">
			<section className="write-head">
				<h1>Write a new Blog!</h1>
				{!breakpoint("mobile") && (
					<Button
						text="Publish Blog"
						icon="publish"
						onClick={handleSubmit}
					/>
				)}
			</section>
			<form onSubmit={handleSubmit} onReset={handleReset}>
				<Input
					type="text"
					placeholder="Title text"
					icon="title"
					name="title"
					value={newBlog.title}
					onChange={handleChange}
					required
				/>
				<Input
					type="text"
					placeholder="Short Description"
					icon="info"
					name="about"
					value={newBlog.about}
					onChange={handleChange}
					required
				/>
				<Input
					type="url"
					placeholder="Cover Image URL"
					icon="image"
					name="image"
					value={newBlog.image}
					onChange={handleChange}
					required
				/>
				<Input
					type="text"
					placeholder="Events (Select from List or add a new one)"
					icon="festival"
					name="event"
					value={newBlog.event}
					list="eventSuggestions"
					onChange={handleChange}
					required
				/>
				<datalist id="eventSuggestions">
					{events.map((event) => (
						<option value={event.title} />
					))}
				</datalist>
				<div className="form-flex">
					<TextArea
						type="text"
						placeholder="Blog Content (markdown supported)"
						icon="edit_note"
						name="content"
						value={newBlog.content}
						onChange={handleChange}
						required
					/>
					<div className="form-md">
						<ReactMarkdown remarkPlugins={[remarkGfm]}>
							{newBlog.content}
						</ReactMarkdown>
					</div>
				</div>
				<div className="form-group">
					<Button text="Publish Blog" type="submit" icon="publish" />
				</div>
			</form>
		</main>
	);
};

export default Write;
